import { connectLocation } from '../../location/LocationConnectors';

const FilterList = connectLocation(
  ({ t, filters, filterCounts, appliedFilters, updateParams, resetFilter, loading, showSecondTier = false }) => (
    <>
      {Object.keys(filters)
        .filter(key => !!filters[key].secondTier === showSecondTier)
        .map((filter, index) => {
        const FilterComponent = filters[filter].component;
        const filterProps = filters[filter].props;

        return (
          <FilterComponent
            filterCounts={filterCounts[filter]}
            collapseText={filters[filter].collapseText || t('filter_list.collapse_text')}
            defaultValue={appliedFilters[filter]}
            displayLimit={filters[filter].displayLimit}
            expandText={filters[filter].expandText || t('filter_list.expand_text')}
            filterAttribute={filter}
            key={index}
            loading={loading}
            name={filter}
            onChange={updateParams}
            options={filters[filter].options || []}
            resetFilter={resetFilter}
            title={filters[filter].displayName}
            value={appliedFilters[filter]}
            onComponentChange={filters[filter]?.onComponentChange}
            allFilters={filters}
            allFilterCounts={filterCounts}
            allAppliedFilters={appliedFilters}
            secondTier={filters[filter].secondTier}
            {...filterProps}
          />
        );
      })}
    </>
  )
);

export default FilterList;
